<template>
  <v-container fluid class="fill-height bg-primary">
    <v-row class="d-flex align-center justify-center">
      <v-col cols="12" md="6">
        <v-card
          v-motion-slide-bottom
          class="pa-6 pa-md-12 bg-white text-center"
          elevation="24"
        >
          <div v-if="invalidLink">
            <div class="text-primary text-h5">
              Invalid Link! Please Try Again.
            </div>
          </div>
          <div v-else>
            <div class="my-6 text-primary">
              Reset password for <strong>{{ email }}</strong
              >.
            </div>
            <v-text-field
              v-model="newPassword"
              density="compact"
              @click:append="togglePassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              clearable
              autocomplete="password"
              label="Password"
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              density="compact"
              @click:append="togglePassword"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              clearable
              autocomplete="password"
              label="Confirm Password"
            ></v-text-field>

            <div class="text-left text-caption px-4">
              <div>Password Rules:</div>
              <div
                class="text-left"
                v-for="(pc, idx) in passwordChecks"
                :key="idx"
              >
                <v-icon class="mr-2" :color="pc.valid ? 'green' : 'red'">{{
                  pc.valid ? "mdi-check-circle" : "mdi-close-circle"
                }}</v-icon>
                {{ pc.text }}
              </div>
            </div>
            <div class="mt-6">
              <v-btn
                @click="resetPassword"
                :disabled="!registerFormValid"
                color="primary"
                rounded="lg"
                variant="flat"
              >
                Reset Password
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useFirebaseAuth } from "vuefire";
import { useAlertStore } from "@/store/alert";
import { verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { useRouter } from "vue-router";
const alertStore = useAlertStore();
const auth = useFirebaseAuth();
const router = useRouter();
const mode = router.currentRoute.value.query.mode;
const actionCode = router.currentRoute.value.query.oobCode;

const invalidLink = ref(false);
const email = ref("");
const newPassword = ref("");
const confirmPassword = ref("");
const showPassword = ref(false);
const togglePassword = () => (showPassword.value = !showPassword.value);

if (!actionCode) {
  invalidLink.value = true;
} else if (mode === "resetPassword") {
  verifyPasswordResetCode(auth, actionCode)
    .then((userEmail) => {
      email.value = userEmail;
    })
    .catch((error) => {
      invalidLink.value = true;
    });
} else if (mode === "verifyEmail") {
  // Send them to https://eye-academy-b95b3.firebaseapp.com/__/auth/action with the route params too
  // Get everything after the ? in the current URL
  const params = window.location.href.split("?")[1];
  window.location.href = `https://eye-academy-b95b3.firebaseapp.com/__/auth/action?${params}`;
}

import { usePasswordCheck } from "@/composables/passwordCheck";
const { registerFormValid, passwordChecks } = usePasswordCheck(
  email,
  newPassword,
  confirmPassword,
);

const resetPassword = () => {
  confirmPasswordReset(auth, actionCode, newPassword.value)
    .then(() => {
      alertStore.showAlert(
        "Your password has been reset. Please log in with your new password.",
        "success",
      );
      router.push("/login");
    })
    .catch((error) => {
      alertStore.showAlert(
        "There was an error resetting your password. Please try again or contact support.",
        "error",
      );
    });
};

//   const resetPassword = (closeDialog) => {
//     sendPasswordResetEmail(auth, resetEmail.value)
//       .then(() => {
//         alertStore.showAlert('An email has been sent to reset your password.', 'success')
//         closeDialog.value = false
//       })
//       .catch((error) => {
//         alertStore.showAlert('There was an error sending the reset email. Please try again or contact support.', 'error')
//       });
//   }
</script>
